import type { BrandBorderStyle, BrandBorderWidth } from '$lib/types/Theme';

export const getBorderWidth = (value: BrandBorderWidth): string | undefined =>
    ({
        none: 'fun-border-0',
        thin: 'fun-border',
        medium: 'fun-border-2',
        thick: 'fun-border-4',
    })[value];

export const getBorderStyle = (value: BrandBorderStyle): string | undefined =>
    ({
        solid: 'fun-border-solid',
        dashed: 'fun-border-dashed',
        dotted: 'fun-border-dotted',
    })[value];
